import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Employer             from './Employer';
import SelfEmployed         from './SelfEmployed';
import Independent          from './Independent';
import Pension              from './Pension';

let Quote = require('../../Managers/Quote.js');

class EmploymentPeriod extends Component {
    constructor(props) {
        super(props);
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = [];
        inputComponents = inputComponents.concat(this.inputComponents);
        this.childComponents.filter(component => {
            return (component !== null) && (component !== undefined);
        }).map(component => {
            inputComponents = inputComponents.concat(component.getChildInputComponents());
        });

        return inputComponents;
    }

    forceFinancialReferees(isChangingInFuture) {
        if (this.props.forceFinancialRefereeTwo && (isChangingInFuture === true || isChangingInFuture === false)) {
            this.props.forceFinancialRefereeTwo(isChangingInFuture);
        }

        if (this.props.forceFinancialRefereeThree && (isChangingInFuture === true || isChangingInFuture === false)) {
            this.props.forceFinancialRefereeThree(isChangingInFuture);
        }
    }

    render() {
        let financialRefereeStatus = Quote.get('financialRefereeStatus', this.props.source);
        return(
            <div>
                {/* Employed */}
                {this.props.formType === 1 ?
                    <Employer
                        productId={this.props.productId}
                        termLength={this.props.termLength}
                        source={this.props.source}
                        ref={(instance) => {this.childComponents.push(instance);}}
                        callbackFunction={this.forceFinancialReferees.bind(this)}
                        financialRefereeStatus={financialRefereeStatus}
                    />
                : null}

                {/* Self-employed */}
                {this.props.formType === 2 ?
                    <SelfEmployed
                        productId={this.props.productId}
                        termLength={this.props.termLength}
                        source={this.props.source}
                        ref={(instance) => {this.childComponents.push(instance);}}
                        callbackFunction={this.forceFinancialReferees.bind(this)}
                        financialRefereeStatus={financialRefereeStatus}
                    />
                : null}

                {/* Independent */}
                {this.props.formType === 6 ?
                    <Independent
                        productId={this.props.productId}
                        source={'BaseIndividualApplication'}
                        ref={(instance) => {this.childComponents.push(instance);}}
                        callbackFunction={this.forceFinancialReferees.bind(this)}
                        financialRefereeStatus={financialRefereeStatus}
                    />
                : null}

                {/* Pension */}
                {this.props.formType === 4 ?
                    <Pension
                        productId={this.props.productId}
                        source={this.props.source}
                        ref={(instance) => {this.childComponents.push(instance);}}
                        callbackFunction={this.forceFinancialReferees.bind(this)}
                        financialRefereeStatus={financialRefereeStatus}
                    />
                : null}
            </div>
        );
    }
}

EmploymentPeriod.propTypes = {
    productId:                  PropTypes.number.isRequired,
    termLength:                 PropTypes.number,
    allowAdditional:            PropTypes.bool,
    forceFinancialRefereeTwo:   PropTypes.func,
    forceFinancialRefereeThree: PropTypes.func,
    formType:                   PropTypes.number,
    source:                     PropTypes.string.isRequired,
};

EmploymentPeriod.defaultProps = {
    financialRefereeNumber: 1,
    termLength: 6, // todo: get this from the Case object
    allowAdditional: true,
};

export default EmploymentPeriod;



// WEBPACK FOOTER //
// ./src/components/Screens/Sections/EmploymentPeriod.js